export default __webpack_public_path__ + "static/12_Garryowen-951cb108708178ae3577b890e25f77f4.pdf";